import {createNamespacedHelpers} from "vuex";
import readableNumber from '@core/Util/format-number';

import resourceMixin from "@core/Util/Mixins/resources";

const {mapState, mapGetters, mapActions} = createNamespacedHelpers('audienceManager/builder');


export default {
    name: "Estimate",
    async created(){
        //No total implies we haven't loaded our progress yet
        //Attempt to load progress for our component to display
        if(this.audienceProgress.total === undefined){
            await this.loadProgress();   
        }
    },
    mixins: [resourceMixin],
    filters: {
        readableNumber
    },
    methods: {
        ...mapActions(['loadProgress'])
    },
    computed: {
        ...mapState(['audienceProgress']),
        ...mapGetters(['audienceProgressLastRetrievedDisplay']),
        hasTotal(){
            return this.audienceProgress.total != null;
        },
        totalValue(){
            //TODO: Handle large numbers when displaying
            // return 10000000000;
            
            return this.audienceProgress.total;
        }
    }
}